// Kept apart from BlogShowView.ts, which touches the DOM, so it stays
// unit-testable. Must agree with the island's `parseCommentsHash`.

/**
 * Whether the page's fragment points at the comments: the section
 * (`#comments`) or one comment (`#comment-<id>`). Those need the comments
 * island at once, not when the reader scrolls down.
 */
export function isCommentsLink(hash: string): boolean {
  if (!hash.startsWith('#')) {
    return false
  }

  return hash
    .slice(1)
    .split('&')
    .some(function isCommentsPart(part) {
      const match = /^comment-(\d+)$/.exec(part)

      return part === 'comments' || (match !== null && Number(match[1]) > 0)
    })
}
